import React from 'react';

const Learning = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Learning Resources</h2>
      <div className="text-gray-500 text-center py-12 bg-white shadow-sm border border-gray-200 rounded-xl">
        No resources available at the moment. Check back later!
      </div>
    </div>
  );
};

export default Learning;
